import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSupplier } from "@/api/hooks";
import { SupplierEditorForm } from "@/components/suppliers/SupplierEditorForm";
import { usePageCrumbs } from "@/components/shell/breadcrumb";
import { PageBody } from "@/components/ui/PageHeader";
import { ErrorState, LoadingState } from "@/components/ui/States";

export function SupplierEditorPage() {
  const { id } = useParams();
  return <SupplierEditorLoader key={id ?? "new"} id={id} />;
}

function SupplierEditorLoader({ id }: { id?: string }) {
  const { t } = useTranslation();
  const { data, isLoading, error, refetch } = useSupplier(id);
  const { search } = useLocation();
  usePageCrumbs(!id
    ? [{ label: t("suppliers.newSupplier") }]
    : data
      ? [{ label: data.companyName, to: `/suppliers/${id}${search}` }, { label: t("common.edit") }]
      : [{ label: t(error ? "suppliers.errorLoad" : "common.loading") }], `/suppliers${search}`);
  if (!id) return <SupplierEditorForm />;
  if (isLoading) return <PageBody><LoadingState label={t("suppliers.loading")} /></PageBody>;
  if (error || !data) {
    return <PageBody><ErrorState message={t("suppliers.errorLoad")} onRetry={() => void refetch()} /></PageBody>;
  }
  return <SupplierEditorForm key={id} supplier={data} />;
}
